import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=2336c8a0"
import script from "./AddCandidate.vue?vue&type=script&lang=js"
export * from "./AddCandidate.vue?vue&type=script&lang=js"
import style0 from "./AddCandidate.vue?vue&type=style&index=0&id=2336c8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports